import React from 'react';
import { FieldRenderProps } from 'react-final-form';

export interface RadioWrapperInterface extends FieldRenderProps<string> {}

const FinalFormRadioWrapper: React.FC<RadioWrapperInterface> = (props) => {
  const { component: Component, input, meta, ...otherProps } = props;
  return <Component {...input} {...otherProps} />;
};

export default FinalFormRadioWrapper;
